// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Controls----styles-module---wrapper---g1kH1","control":"src-components-Controls----styles-module---control---1F2sJ","colorPicker":"src-components-Controls----styles-module---colorPicker---1LmzD","controlHeading":"src-components-Controls----styles-module---controlHeading---2W4ZS","fgChooser":"src-components-Controls----styles-module---fgChooser---ZfHfH","sizeChooser":"src-components-Controls----styles-module---sizeChooser---1MevZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Controls/styles.module.css
// module id = 365
// module chunks = 35783957827783